import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useState, useEffect } from "react";

export default function AdminLayout() {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div dir="rtl" className="admin-layout">
      <Header toggleSidebar={toggleSidebar} isMobile={isMobile} />
      
      <div className="layout-container">
        {/* Overlay للجوال */}
        {isMobile && sidebarOpen && (
          <div 
            className="sidebar-overlay"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        
        {/* Sidebar */}
        <aside className={`sidebar-wrapper ${sidebarOpen ? "open" : "closed"}`}>
          <Sidebar />
        </aside>

        {/* المحتوى الرئيسي */}
        <main className="main-content">
          <div className="content-container">
            <Outlet />
          </div>
        </main>
      </div>

      <style jsx>{`
        .admin-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background-color: #f5f7fb;
        }

        .layout-container {
          display: flex;
          flex: 1;
          position: relative;
        }

        .sidebar-wrapper {
          width: 220px;
          height: calc(100vh - 60px);
          position: sticky;
          top: 60px;
          transition: all 0.3s ease;
          z-index: 100;
          overflow-y: auto;
        }

        .sidebar-overlay {
          position: fixed;
          top: 60px;
          right: 0;
          left: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 99;
        }

        .main-content {
          flex: 1;
          min-height: calc(100vh - 60px);
          padding: 0;
          overflow-y: auto;
        }

        .content-container {
          max-width: 100%;
          margin: 0 auto;
          padding: 24px;
          text-align: right;
        }

        /* Responsive Design */
        @media (min-width: 1200px) {
          .content-container {
            max-width: 1140px;
            padding: 32px;
          }
        }

        @media (min-width: 992px) and (max-width: 1199px) {
          .content-container {
            max-width: 960px;
            padding: 28px;
          }
        }

        @media (min-width: 768px) and (max-width: 991px) {
          .content-container {
            max-width: 720px;
            padding: 24px;
          }
        }

        @media (max-width: 767px) {
          .layout-container {
            flex-direction: column;
          }

          .sidebar-wrapper {
            position: fixed;
            top: 60px;
            right: ${sidebarOpen ? "0" : "-220px"};
            width: 220px;
            height: calc(100vh - 60px);
            background: white;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
            transition: right 0.3s ease;
          }

          .sidebar-wrapper.closed {
            right: -220px;
          }

          .sidebar-wrapper.open {
            right: 0;
          }

          .main-content {
            width: 100%;
            padding: 0;
          }

          .content-container {
            padding: 20px 16px;
            max-width: 100%;
          }
        }

        @media (max-width: 480px) {
          .content-container {
            padding: 16px 12px;
          }
        }

        /* تحسينات للطباعة */
        @media print {
          .sidebar-wrapper {
            display: none;
          }
          
          .main-content {
            width: 100%;
            padding: 0;
          }
          
          .content-container {
            max-width: 100%;
            padding: 20px;
          }
        }

        /* تحسينات للأجهزة اللوحية */
        @media (min-width: 768px) and (max-width: 1024px) {
          .sidebar-wrapper {
            width: 200px;
          }
        }

        /* تحسينات للشاشات الكبيرة جداً */
        @media (min-width: 1600px) {
          .content-container {
            max-width: 1400px;
          }
        }

        /* تحسينات للأجهزة ذات الشاشات الصغيرة جداً */
        @media (max-width: 360px) {
          .content-container {
            padding: 12px 8px;
          }
        }

        /* تحسينات لتحسين الأداء */
        .main-content {
          -webkit-overflow-scrolling: touch;
        }

        .sidebar-wrapper {
          scrollbar-width: thin;
          scrollbar-color: #c1c1c1 transparent;
        }

        .sidebar-wrapper::-webkit-scrollbar {
          width: 6px;
        }

        .sidebar-wrapper::-webkit-scrollbar-track {
          background: transparent;
        }

        .sidebar-wrapper::-webkit-scrollbar-thumb {
          background-color: #c1c1c1;
          border-radius: 3px;
        }
      `}</style>
    </div>
  );
}